import React, {CSSProperties} from 'react';
import './styles.scss';
import Logo from '../../../static/Logo';
import {selectUser} from "../../../db/selectors";
import {useSelector} from "react-redux";

const TitleHeader = (): React.ReactElement => {
  const user = useSelector(selectUser)

  if (window.location.pathname.includes('/documents/')) {
    return <div/>
  }

  // todo - replace this, smells to high heaven
  const index = window.location.pathname.lastIndexOf('/')
  const isRootWindow = index === 0
  const style: CSSProperties = isRootWindow ? {'margin': '0 auto'} : {}
  return (
    <div className="title-header">
      <div className="th-logo" style={style}>
        <Logo/>
      </div>
      <div className="th-img">
        {
          user.picture
            ? <img src={user.picture} alt="avatar" style={{borderRadius: "50%", width: "40px", height: "40px"}}/>
            : <div/>
        }
      </div>
    </div>
  );
};

export default TitleHeader;
